import { mapState } from "vuex";
import ClientServiceV2 from "@/services/ClientServiceV2";
import { lookupClientFields } from "@/utils/clientFields";

export default {
  data() {
    return {
      ClientService: new ClientServiceV2(),
    };
  },
  computed: {
    ...mapState(["globalClientId", "userProfile", "clients"]),
  },

  methods: {
    async getClientField(field, clientId = this.globalClientId) {
      return (await this.getClientFields([field], clientId))[field];
    },

    // Dropdown, then user profile, then a single getClientV3 for anything still missing.
    getClientFields(fields, clientId = this.globalClientId, options) {
      return lookupClientFields(
        { clients: this.clients, userProfile: this.userProfile },
        fields,
        clientId,
        this.ClientService,
        options
      );
    },
  },
};
